export default "__VITE_ASSET__50db79c9__"